export default __webpack_public_path__ + "static/media/man.9486e5c1.png";